import React from 'react'
import './layout.css';
import { Link } from 'react-router-dom';
import { FaCogs, FaGrinHearts, FaHeart, FaHome, FaUsers } from "react-icons/fa";

function SideNavigation() {
  return (
    <div className="side-dashboard">
        <div className="nav-logo-box">
            <img src="https://lovedripp.co.za/static/media/lovedripp.a831672818d058c6cbb5.png" className="logo-nav"/>
        </div>
        <div className="logo-box">
            <div className="title-nav">
                Navigation
            </div>
            <div className="list-items-nav">
                <ul className="nav nav-pills flex-column mb-auto">
                    <li>
                        <Link to={"/dashboard"} className="nav-item">
                            <span className="nav-icon-area">
                                <FaHome />
                            </span>
                            <span className="nav-text">Home</span>
                        </Link>
                    </li>
                    <li>
                        <Link to={"/onsites"} className="nav-item">
                            <span className="nav-icon-area"><FaGrinHearts /></span>
                            <span className="nav-text">Onsites</span>
                        </Link>
                    </li>
                    <li>
                        <Link to={"/annisites"} className="nav-item">
                            <span className="nav-icon-area"><FaHeart /></span>
                            <span className="nav-text">Annisites</span>
                        </Link>
                    </li>
                    <li>
                        <Link to={"/users"} className="nav-item">
                            <span className="nav-icon-area"><FaUsers /></span>
                            <span className="nav-text">Users</span>
                        </Link>
                    </li>
                    <li>
                      
                        <Link to={"/settings"} className="nav-item">
                            <span className="nav-icon-area"><FaCogs /></span>
                            <span className="nav-text">Settings</span>
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
  )
}

export default SideNavigation